<template>
  <div class="w-full">
    <lcontainer class="mb-4">
      <div class="heading flex flex-row items-center justify-between py-2 px-8">
        <div v-if="$route.name !== 'tenant-survey-create'">
          <div class="page text-white">Surveys and Feedback</div>
          <lms-button
            color="#fff"
            class="text-center"
            @click="$router.push({ name: 'tenant-survey-create' })"
            >Create Survey</lms-button
          >
        </div>
        <div v-if="$route.name == 'tenant-survey-create'">
          <div class="page text-white">Create a new survey</div>
          <!-- <lms-button class="mt-4" @click="$router.push({name: 'tenant-survey-create'})">Create Survey</lms-button> -->
        </div>
        <div>
          <img :src="require('../../../assets/tenant_image.png')" alt="" />
        </div>
      </div>
    </lcontainer>
    <router-view />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    LmsButton: () => import("@/components/general/button"),
    lcontainer: () => import("@/components/general/container"),
  },
};
</script>
<style scoped></style>
